import { useState } from "react";
import { StatusBadge } from "../../StatusBadge";

const today = () => new Date().toISOString().slice(0, 10);

export const SelfRequestForm = ({ onSubmit, busy }) => {
  const [form, setForm] = useState({ date: today(), check_in: "09:00", check_out: "18:00", half_day: false });

  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(form); }}
      className="p-4 flex flex-wrap items-end gap-3 border-b border-stone-100" data-testid="self-attendance-form">
      <div>
        <label className="text-xs font-semibold text-stone-500">Date</label>
        <input type="date" required max={today()} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })}
          data-testid="self-attendance-date" className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
      </div>
      <div>
        <label className="text-xs font-semibold text-stone-500">Day type</label>
        <select value={form.half_day ? "half" : "full"} data-testid="self-attendance-daytype"
          onChange={(e) => { const h = e.target.value === "half"; setForm({ ...form, half_day: h, check_out: h ? "13:30" : "18:00" }); }}
          className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
          <option value="full">Full day</option>
          <option value="half">Half day</option>
        </select>
      </div>
      <div>
        <label className="text-xs font-semibold text-stone-500">Check-in</label>
        <input type="time" required value={form.check_in} onChange={(e) => setForm({ ...form, check_in: e.target.value })}
          data-testid="self-attendance-in" className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
      </div>
      <div>
        <label className="text-xs font-semibold text-stone-500">Check-out</label>
        <input type="time" value={form.check_out} onChange={(e) => setForm({ ...form, check_out: e.target.value })}
          data-testid="self-attendance-out" className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
      </div>
      <button type="submit" disabled={busy} data-testid="self-attendance-submit"
        className="tap-scale px-5 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200 disabled:opacity-60">
        {busy ? "Sending…" : "Send for approval"}
      </button>
    </form>
  );
};

export const SelfRequestRow = ({ r, isSuperAdmin, onReview }) => (
  <div className="px-4 py-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`self-request-row-${r.id}`}>
    <div className="flex-1 min-w-[180px]">
      <span className="font-semibold">{r.employee_name}</span>
      <div className="text-xs text-stone-500 tabular-nums">
        {r.date} · {r.check_in} → {r.check_out || "—"}{r.half_day ? " · half day" : ""}
        {r.reviewed_by ? ` · by ${r.reviewed_by}` : ""}
      </div>
    </div>
    {isSuperAdmin && r.status === "pending" ? (
      <div className="flex gap-2">
        <button onClick={() => onReview(r.id, "approved")} data-testid={`approve-self-request-${r.id}`}
          className="tap-scale px-4 py-2 rounded-full bg-secondary text-white text-xs font-bold hover:bg-[#1E2B22] transition-colors duration-200">Approve</button>
        <button onClick={() => onReview(r.id, "rejected")} data-testid={`reject-self-request-${r.id}`}
          className="tap-scale px-4 py-2 rounded-full bg-white border border-red-300 text-red-600 text-xs font-bold hover:bg-red-50 transition-colors duration-200">Reject</button>
      </div>
    ) : (
      <StatusBadge status={r.status} testId={`self-request-status-${r.id}`} />
    )}
  </div>
);
